export const LocalizationKeys = {
  ManualCpc: _TL_('Fixed bid per night (per click)'),
  PercentCpc: _TL_('Percentage of room price (per click)'),
  Commission: _TL_('Percentage of room price (per stay)'),
  Individual: _TL_('Individual budget'),
  individual: _TL_('Individual budget'),
  'Increase by': _TL_('Increase by'),
  'Decrease by': _TL_('Decrease by'),
  UrlCustomParameters: _TL_('Custom parameters'),
  TrackingUrlTemplate: _TL_('Tracking template'),
  FinalUrlSuffix: _TL_('Final URL suffix'),
  ExcludedSites: _TL_('Website'),
  ExcludedIPs: _TL_('IP Address'),
  Targeted: _TL_('Targeted'),
  Computer: _TL_('Computer'),
  Desktop: _TL_('Desktop'),
  Tablet: _TL_('Tablet'),
  Smartphone: _TL_('Smartphone'),
  Monday: _TL_('Monday'),
  Tuesday: _TL_('Tuesday'),
  Wednesday: _TL_('Wednesday'),
  Thursday: _TL_('Thursday'),
  Friday: _TL_('Friday'),
  Saturday: _TL_('Saturday'),
  Sunday: _TL_('Sunday'),
  'Selected date': _TL_('Selected date'),
  'Default date': _TL_('Default date'),
};

export const ConversionGoalKeyToStringMapping = {
  Campaign_Goals_Account_Level_Label: _TL_('Use the account "Include in conversions" setting'),
  Campaign_Goals_Account_Level_Subtext: _TL_('This option applies the same conversion goals that you have selected at the account level to this campaign.'),
  Campaign_Goals_Campaign_Level_Label: _TL_('Choose conversion goals for this campaign'),
  Campaign_Goals_Campaign_Level_Subtext: _TL_('This option allows you to select specific conversion goals for this campaign only.'),
  GoalSelector_List_Header: _TL_('Available goals: {{itemCount}}'),
  GoalSelector_Result_List_Header: _TL_('Selected goal: {{itemCount}}'),
  GoalSelector_Radio_Aria_Label: _TL_('Select which conversions are included in the Conversion columns for this campaign and used for optimizing your bid strategy. Updating this setting will override the “Include in conversions” setting made at the account level.'),
  GoalSelector_EmptyList_Content: _TL_('No results to display.'),
  EntitySelector_Search_Placeholder: _TL_('Search'),
  UnifiedEventTracking_Goal_Creation_Type_Event_Category: _TL_('Category'),
  GoalSelector_Result_Action_Bar: _TL_('Select all on this page'),
  GoalSelector_TrackingStatus_Value_InactiveDueToTagUnavailable: _TL_('This goal is not associated with an active UET tag. Verify the tag setup and associate the goal with a valid UET tag.'),
  GoalSelector_TrackingStatus_Value_NoRecentConversion: _TL_("This goal doesn't have enough conversions to optimize campaign performance because it hasn't recorded conversions in the past 7 days. Ensure that for an online goal, the UET tag is placed on every webpage."),
  GoalSelector_TrackingStatus_Value_RecordingConversions: _TL_("We've seen your UET tag and have recorded conversions within the last 7 days. If your conversion window is greater than 7 days and you are filtering on the last 7 days, you may see this status even if no conversions are shown in the Conversions column, as conversions are reported at the time of the click."),
  GoalSelector_TrackingStatus_Value_TagInactive: _TL_('No website activity data has been received from the UET tag associated with this goal in the past 24 hours. Verify the UET tag setup or associate the goal with an active tag.'),
  GoalSelector_TrackingStatus_Value_Unverified: _TL_("We haven't received any data from the UET tag for this goal. For new goals, allow 24 hours for conversions to start recording. Otherwise, verify the UET tag setup or associate this goal with an active tag."),
  Segment_Goal_Category_Download: _TL_('Download'),
  Segment_Goal_Category_Purchase: _TL_('Purchase'),
  Segment_Goal_Category_AddToCart: _TL_('Add to cart'),
  Segment_Goal_Category_BeginCheckout: _TL_('Begin checkout'),
  Segment_Goal_Category_BookAppointment: _TL_('Book appointment'),
  Segment_Goal_Category_Contact: _TL_('Contact'),
  Segment_Goal_Category_GetDirections: _TL_('Get directions'),
  Segment_Goal_Category_InStoreVisit: _TL_('In-store visit'),
  Segment_Goal_Category_Other: _TL_('Other'),
  Segment_Goal_Category_OutboundClick: _TL_('Outbound click'),
  Segment_Goal_Category_PageView: _TL_('Page view'),
  Segment_Goal_Category_RequestQuote: _TL_('Request quote'),
  Segment_Goal_Category_SignUp: _TL_('Sign-up'),
  Segment_Goal_Category_SubmitLeadForm: _TL_('Submit lead form'),
  Segment_Goal_Category_Subscribe: _TL_('Subscribe'),
  Segment_Goal_Category_Unassigned: _TL_('Unassigned'),
  Campaign_Goals_Option_Goals: _TL_('Goals'),
  Campaign_Goals_Option_GoalSets: _TL_('Goal Sets'),
  EntitySelector_Pagination_Page: _TL_('Page:'),
  EntitySelector_Pagination_TotalPageCountText: _TL_('of'),
  EntitySelector_Pagination_PreviousPageText: _TL_('Previous page'),
  EntitySelector_Pagination_NextPageText: _TL_('Next page'),
  'Remove all': 'Remove all',
  'No results found for {{searchText}}': _TL_('No results found for {{searchText}}'),
  'Found {{totalCount}} Results for {{searchText}}': _TL_('Found {{totalCount}} Results for {{searchText}}'),
};
